export enum OnboardingGuideStatus {
  Show = 10,
  Available = 20,
  NotAvailable = 30,
}
